import ApiCall from "../../Apicall/ApiCall";

// Remember which step of the deal flow this user is on (stored per party on the
// contract) so a re-login after a manual/idle sign-out can put them back there.
// Best effort: never block or break the flow.
export async function saveDealStep(contractId, step) {
  if (!contractId || !Number.isFinite(step)) return;
  try {
    await ApiCall({
      url: "/ContractMain/SaveDealStep",
      method: "POST",
      data: { id: Number(contractId), step },
    });
  } catch (_) {
    /* ignore */
  }
}
